import type ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';
import { mutatorAction } from 'satcheljs';

export const setShowDecryptedContent = mutatorAction(
    'setShowDecryptedContent',
    function (viewState: ItemReadingPaneViewState, isShow: boolean) {
        viewState.showDecryptedContent = isShow;
    }
);
